import Api from "./axiosVersion1";
import OldApi from './axios';

export const getHistory = async (card_id) => {
  return await Api.get(`/card-history/${card_id}`);
};

export const getFeeds = async (board_id, page, pageSize, filters = {}) => {
  const {
    milestoneId,
    user_ids,
    start_date,
    end_date
  } = filters;

  let queryParams = `page=${page}&page_size=${pageSize}`;
  
  if (milestoneId) {
    queryParams += `&milestone_id=${milestoneId}`;
  }
  
  if (user_ids && user_ids.length > 0) {
    user_ids.forEach(userId => {
      queryParams += `&user_ids=${userId}`;
    });
  }
  
  if (start_date) {
    queryParams += `&start_date=${encodeURIComponent(start_date)}`;
  }
  
  if (end_date) {
    queryParams += `&end_date=${encodeURIComponent(end_date)}`;
  }

  return await OldApi.get(`/feeds/${board_id}?${queryParams}`);
};
